exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#app{width:800px;margin:0 auto}html{overflow-y:auto;background-color:#e1e1e1;height:100%}button{display:block}.fishpond{width:calc(400px - 2em);padding:1em;background:#fff;border-radius:25px;display:inline-block;margin:1em}.fishpond-name{text-align:center;font-weight:700}body{color:#000}.main-container{padding:0 2em}.input.is-active,.input.is-focused,.input:active,.input:focus,.textarea.is-active,.textarea.is-focused,.textarea:active,.textarea:focus{border-color:#00d1b2;box-shadow:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-393e7fb0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 169
// module chunks = 0